export const API_ORGANISATIONS_ALL = 'API_ORGANISATIONS_ALL'
// Internal per-page request action whose success/failure the fetch-all saga
// awaits while paginating. Routed through AUTHED_REQUEST so auth/global error
// handling is reused.
export const API_ORGANISATIONS_PAGE = 'API_ORGANISATIONS_PAGE'

export const fetchAllOrganisations = () => ({
  type: API_ORGANISATIONS_ALL,
})
